import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import { NavItemBadge } from "@similarweb/ui-components";
import { Text } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { StyledAIAgentPageLogo } from "./styles";

const AIAgentPageLogo = ({ isLogoFading, onAnimationEnd }: { isLogoFading?: boolean; onAnimationEnd?: () => void }) => {
    return (
        <StyledAIAgentPageLogo
            gap="8px"
            alignSelf="flex-start"
            alignItems="center"
            margin="24px 28px"
            isLogoFading={isLogoFading}
            onAnimationEnd={onAnimationEnd}
        >
            <SWReactIcons
                iconName="sparkless-ai-purple-gradient"
                size="lg"
            />
            <Text
                fontVariant="h5"
                color={colorsPalettes.carbon[500]}
            >
                {translate("primary.sidebar.salesIntelligence.meeting")}
            </Text>
            <NavItemBadge type="beta" />
        </StyledAIAgentPageLogo>
    );
};

export default AIAgentPageLogo;
